/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.94"
        height="14.83"
        viewBox="0 0 18.94 14.83"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M18.94 2.25h-6.75V0H6.7v2.25H-.02v12.58h18.94ZM7.72 1h3.47v1.25H7.7ZM3.34 13.83H1V3.25h2.34Zm11.24 0H4.34V3.25h10.24Zm3.35-10.58v10.58h-2.35V3.25Zm-7.91 2.59v1.9h1.89v1h-1.89v1.9h-1v-1.9h-1.9v-1h1.9v-1.9Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'BriefcaseWithCrossIcon';

export default Icon;
